import React from 'react';
import './Ticker.css';

export default function Ticker({ text }) {
  return (
    <div className="ticker">
      <span className="ticker-inner">{text}</span>
    </div>
  );
}
